import React from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';

import { useResponsive } from '../../../../../hooks';
import { type Props } from './NoticeBannersStackWrapper.types';

// ────────────────────────────────────────────────────────────────────────────────

export const NoticeBannersStackWrapper = (props: Props) => {
  const { style, children, ...restProps } = props;

  const { match } = useResponsive();

  return (
    <Animated.View
      style={[style, match([styles.wrapperXs, undefined])]}
      pointerEvents="none"
      {...restProps}
    >
      {children}
    </Animated.View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapperXs: {
    flexDirection: 'column-reverse',
  },
});
